export const forgotPasswordValidatePasswords = (password, confirmPassword, translateText) => {
  const passwordValidationConfiguration = {
    regexAllowOnlyUnderscoreSymbol: /^(?!.*\W)_?.+$/,
    minimumSize: 4
  }

  const isRequiredRuleFailed = () => {
    if ([password, confirmPassword].every(value => !value)) {
      return {field: 'all', translatedMessage: translateText({key: 'common_error_input_field_required'})}
    } else if (!password) {
      return {field: 'password', translateMessage: translateText({key: 'common_error_input_field_required'})}
    } else if (!confirmPassword) {
      return {field: 'confirmPassword', translateMessage: translateText({key: 'common_error_input_field_required'})}
    }

    return null
  }

  const isMinCharsRuleFailed = () => {
    if (password.length < passwordValidationConfiguration.minimumSize) {
      return {
        field: 'password',
        translatedMessage: translateText({key: 'visitor_forgot_password_error_password_size_restriction_pt1'}) + ' ' + passwordValidationConfiguration.minimumSize + ' ' + translateText({key: 'visitor_forgot_password_error_password_size_restriction_pt2'})
      }
    }

    return null
  }

  const isPasswordContentCriteriaRuleFailed = () => {
    if (!password.match(passwordValidationConfiguration.regexAllowOnlyUnderscoreSymbol)) {
      return {field: 'password', translatedMessage: translateText({key: 'visitor_forgot_password_error_password_symbol_restriction'})}
    }

    return null
  }

  const isMatchPasswordsRuleFailed = () => {
    if (password !== confirmPassword) {
      return {field: 'confirmPassword', translatedMessage: translateText({key: 'visitor_forgot_password_error_passwords_do_not_match'})}
    }

    return null
  }

  const errorConfiguration = isRequiredRuleFailed() || isMinCharsRuleFailed() || isPasswordContentCriteriaRuleFailed() || isMatchPasswordsRuleFailed()

  return {
    invalid: !!errorConfiguration,
    configuration: errorConfiguration
  }
}



// WEBPACK FOOTER //
// ./src/helpers/forgotPassword.js